import { useEffect } from 'react';
import cssVariables from '../../styles/variables';
import { HOME_BROWSE_PATH } from '../../constants/paths';
import TuneInMarquee from '../shared/svgIcons/TuneInMarquee';
import css from './discordSplash.module.scss';

export default function DiscordSplash({ isDiscordReady, history }) {
  useEffect(() => {
    if (isDiscordReady && history.location.pathname !== HOME_BROWSE_PATH) {
      history.replace(HOME_BROWSE_PATH);
    }
  }, [isDiscordReady, history]);

  return (
    <div id="discord-splash" className={css.discordSplash}>
      <div className={css.logo}>
        <TuneInMarquee fill={cssVariables['--anti-flash-white']} />
      </div>
      <div className={css.spinner} />
    </div>
  );
}
